import { render, staticRenderFns } from "./InventoryBySerialCard.vue?vue&type=template&id=3b0d0d5c&"
import script from "./InventoryBySerialCard.vue?vue&type=script&lang=js&"
export * from "./InventoryBySerialCard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryBySerialCard.vue?vue&type=style&index=0&id=3b0d0d5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports